<template>
    <div>
        <header-portrate />
        <div style="margin-bottom:70px;">
            <tabs-comp :tabs="tabs" />
            <v-row class="mainrow m-2" :style="`background:#d7b10015;direction:`+lang.dir+`;margin-top:100px !important;border:1px solid #555;border-radius:10px`">
                <v-col cols="12" md="3" sm="12">
                    <label>{{lang.session || 'Session'}}</label>
                    <b-form-input
                        class="inborder"
                        v-model="session_name"
                        readonly
                    ></b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12">
                    <label>{{lang.status}}</label>
                    <b-form-input
                        class="inborder"
                        v-model="status[`name_`+lang.langname]"
                        readonly
                        :style="status.style"
                    ></b-form-input>
                </v-col>
                <v-col cols="12" md="3" sm="12">
                    <label>{{lang.mobile || 'Phone number'}}</label>
                    <b-form-input
                        class="inborder"
                        v-model="phone"
                        readonly
                    ></b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12">
                    <label>{{lang.last_check || 'Last checked'}}</label>
                    <b-form-input
                        class="inborder"
                        v-model="last_check"
                        readonly
                    ></b-form-input>
                </v-col>
                <v-col cols="12" md="2" sm="12" v-b-toggle.scanQR>
                    {{ status.name_en === 'Connected' ? (lang.reconnect || 'Reconnect WhatsApp') : (lang.connect_whatsapp || 'Scan QR Code for WhatsApp Connect') }}
                </v-col>
                <v-col cols="12" md="2" sm="12">
                    <router-link to="/whatsapp-outbox" style="display:block;text-align:center;background:#000;color:#fff;border-radius:5px;padding:6px 0;text-decoration:none;">
                        {{ lang.message_log || 'Message Log' }}
                    </router-link>
                </v-col>
                <v-col cols="12" md="2" sm="12">
                    <router-link to="/whatsapp-templates" style="display:block;text-align:center;background:#000;color:#fff;border-radius:5px;padding:6px 0;text-decoration:none;">
                        {{ lang.message_templates || 'Message Templates' }}
                    </router-link>
                </v-col>
                <v-col cols="12" md="6" sm="12" v-for="(day,index) in days" :key="index">
                    <v-row>
                        <v-col cols="6">
                            <label>{{day[`name${lang.langname}`]}} {{lang.working_time_star}}</label>
                            <b-form-input type="time" class="inborder" v-model="time_start[day.short]" />
                        </v-col>
                        <v-col cols="6">
                            <label>{{day[`name${lang.langname}`]}} {{lang.working_time_end}}</label>
                            <b-form-input type="time" class="inborder" v-model="time_end[day.short]" />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
        <ScanQR ref="scanQRCode" @connected="getWhatsSettings" />
        <Footer />
    </div>
</template>

<script>
import HeaderPortrate from '@/components/Header-Portrate.vue'
import Footer from '@/components/Footer.vue'
import TabsComp from '@/components/tabsComp.vue'
import axios from 'axios'
import ScanQR from '@/components/scanQR.vue'
export default{
    components: {
        HeaderPortrate, Footer,
        TabsComp,
        ScanQR
    },
    data() {
        return {
            time_start: {
                mon: '09:00',
                tue: '09:00',
                wed:'09:00',
                thu: '09:00',
                fri: '00:00',
                sat: '09:00',
                sun: '09:00'
            },
            time_end: {
                mon: '18:00',
                tue: '18:00',
                wed:'18:00',
                thu: '18:00',
                fri: '00:00',
                sat: '18:00',
                sun: '18:00'
            },
            session_name: '',
            phone: '',
            last_check: '',
            status: {
                name_ar: this.$store.state.lang.ar.not_connected || 'غير متصل',
                name_en: 'Not connected',
                style: 'background:darkred !important;color:#fff !important'
            },
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        days: function(){
            return [
                {namear: this.lang.saturday, nameen: 'Sat',short: 'sat'},
                {namear: this.lang.sunday, nameen: 'Sun',short: 'sun'},
                {namear: this.lang.monday, nameen: 'Mon',short: 'mon'},
                {namear: this.lang.tuesday, nameen: 'Tue',short: 'tue'},
                {namear: this.lang.wednesday, nameen: 'Wed',short: 'wed'},
                {namear: this.lang.thursday, nameen: 'Thu',short: 'thu'},
                {namear: this.lang.friday, nameen: 'Fri',short: 'fri'},
            ]
        },
        tabs: function(){

            const menu = this.$store.getters['state'].menu;
            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });

            let t = []
            Object.values(cMenu).forEach(value =>{

                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                // // console.log("value",license);
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                      if(alicense[value.perms[0]] || value.perms[0] == 'any')
                          t.push(value)
                    }
                }
            })

            return t;
      },
    },
    methods: {
        statusDisplay(status){
            const map = {
                WORKING: { name_ar: 'متصل', name_en: 'Connected', style: 'background:darkgreen !important;color:#fff !important' },
                SCAN_QR_CODE: { name_ar: 'بانتظار المسح', name_en: 'Scan QR', style: 'background:#b8691f !important;color:#fff !important' },
                STARTING: { name_ar: 'جاري البدء', name_en: 'Starting', style: 'background:#b8691f !important;color:#fff !important' },
                FAILED: { name_ar: 'فشل الاتصال', name_en: 'Failed', style: 'background:darkred !important;color:#fff !important' },
            };
            return map[status] || { name_ar: 'غير متصل', name_en: 'Not connected', style: 'background:darkred !important;color:#fff !important' };
        },
        async getWhatsSettings(){
            const post = new FormData();
            post.append("type","wahaSessionStatus");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase))
            post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
            post.append("data[id]", 0);
            const response = await axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            )
            if(response && response.data && response.data.results && response.data.results.data){
                const data = response.data.results.data;
                this.session_name = data.name || '';
                this.status = this.statusDisplay(data.status);
                this.phone = (data.me && data.me.id) ? data.me.id.split('@')[0] : '';
                this.last_check = data.last_check || '';
            }
        }
    },
    created(){
        this.getWhatsSettings()
    }

}
</script>
